import {
    ActionIcon,
    AppShell,
    Burger,
    Group,
    Text,
    useComputedColorScheme,
    useMantineColorScheme,
} from '@mantine/core';
import { DatesProvider } from '@mantine/dates';
import { useDisclosure } from '@mantine/hooks';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import { IconMoon, IconSun } from '@tabler/icons-react';
import React from 'react';
import { Link } from 'react-router';

import env from '../app/env';
import logo from '../assets/logo.png';
import { DevWarningBanner } from '../components/DevWarningBanner';
import { Sidebar } from '../components/Sidebar';

const BANNER_HEIGHT = 28;
const HEADER_HEIGHT = 64;

export const Layout = ({ children }: { children: React.ReactNode }) => {
    const [mobileOpened, { toggle: toggleMobile, close: closeMobile }] = useDisclosure();
    const { toggleColorScheme } = useMantineColorScheme();
    const computedColorScheme = useComputedColorScheme('light');
    const headerHeight = env.IS_DEV ? HEADER_HEIGHT + BANNER_HEIGHT : HEADER_HEIGHT;

    return (
        <DatesProvider settings={{}}>
            <ModalsProvider>
                <Notifications position="top-right" />
                <AppShell
                    header={{ height: headerHeight }}
                    navbar={{ width: 240, breakpoint: 'md', collapsed: { mobile: !mobileOpened, desktop: false } }}
                >
                    <AppShell.Header>
                        <DevWarningBanner />
                        <Group justify="space-between" h={HEADER_HEIGHT} px={{ base: 'sm', sm: 'md', lg: 'lg' }}>
                            <Link to="/" style={{ textDecoration: 'none' }}>
                                <Group gap="xs">
                                    <img
                                        src={logo}
                                        alt="Marketing Tool Logo"
                                        style={{ width: 32, height: 32, objectFit: 'contain' }}
                                    />
                                    <Text fw={600} size="lg">
                                        Marketing Tool
                                    </Text>
                                </Group>
                            </Link>
                            <Group gap="xs">
                                <ActionIcon
                                    variant="subtle"
                                    onClick={toggleColorScheme}
                                    aria-label="Toggle color scheme"
                                >
                                    {computedColorScheme === 'dark' ? <IconSun size={18} /> : <IconMoon size={18} />}
                                </ActionIcon>
                                <Burger opened={mobileOpened} onClick={toggleMobile} hiddenFrom="md" />
                            </Group>
                        </Group>
                    </AppShell.Header>

                    <AppShell.Navbar>
                        <Sidebar onNavItemClick={closeMobile} />
                    </AppShell.Navbar>

                    <AppShell.Main>{children}</AppShell.Main>
                </AppShell>
            </ModalsProvider>
        </DatesProvider>
    );
};
